<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <svg
    viewBox="0 0 181 154"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
    <title>home-chef-enthusiasts</title>
    <desc>Created with Sketch.</desc>
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd">
      <g
        id="Desktop-HD"
        transform="translate(-900.000000, -443.000000)">
        <g
          id="home-chef-enthusiasts"
          transform="translate(901.000000, 443.000000)">
          <g id="Background">
            <g id="New_Symbol_80-72">
              <path
                id="Path"
                d="M172.125007,82.1659091 C172.121871,48.7526127 151.801398,18.6985377 120.794488,6.24783904 C89.7875772,-6.20285963 54.3252861,1.45187353 31.2149978,25.5840711 C8.10470947,49.7162688 1.99059909,85.4763958 15.7704545,115.915909 L164.822727,115.915909 C169.639774,105.316706 172.129758,93.8083751 172.125007,82.1659091 Z"
                class="fill-extra-light"
                fill-rule="nonzero" />
              <line
                id="Path"
                x1="9.51136364"
                y1="115.915909"
                x2="169.056818"
                y2="115.915909"
                class="stroke"
                stroke-width="2.04545455"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <line
                id="Path"
                x1="0.306818182"
                y1="115.915909"
                x2="5.42045455"
                y2="115.915909"
                class="stroke"
                stroke-width="2.04545455"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <line
                id="Path"
                x1="173.147727"
                y1="115.915909"
                x2="178.261364"
                y2="115.915909"
                class="stroke"
                stroke-width="2.04545455"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </g>
          </g>
          <g
            id="Scene"
            transform="translate(33.727273, 6.136364)">
            <ellipse
              id="Oval"
              class="fill-extra-light"
              fill-rule="nonzero"
              cx="27.125"
              cy="143.365909"
              rx="23.5227273"
              ry="3.51818182" />
            <path
              id="Path"
              d="M11.6204545,95.3795455 L11.6204545,140.543182 L22.9113636,140.543182 L24.2,110.904545 C24.2,109.277816 25.5187249,107.959091 27.1454545,107.959091 C28.7721842,107.959091 30.0909091,109.277816 30.0909091,110.904545 L31.3795455,140.543182 L42.6704545,140.543182 L42.6704545,95.3795455 L11.6204545,95.3795455 Z"
              class="fill-white"
              fill-rule="nonzero" />
            <path
              id="Path"
              d="M11.6204545,95.3795455 L11.6204545,140.543182 L22.9113636,140.543182 L24.2,110.904545 C24.2,109.277816 25.5187249,107.959091 27.1454545,107.959091 C28.7721842,107.959091 30.0909091,109.277816 30.0909091,110.904545 L31.3795455,140.543182 L42.6704545,140.543182 L42.6704545,95.3795455 L11.6204545,95.3795455 Z"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M9.84090909,138.293182 C9.35921456,139.027718 9.32691378,139.969445 9.75714694,140.73526 C10.1873801,141.501075 11.0084595,141.963374 11.8863636,141.934091 L21.5,141.934091 C22.3141469,141.91958 23.0628841,141.485043 23.4793733,140.785341 C23.8958624,140.085639 23.920859,139.220304 23.5454545,138.497727 C20.9681818,133.588636 12.7863636,133.854545 9.84090909,138.293182 Z"
              class="stroke fill-light"
              stroke-width="2.04545455"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M44.4295455,138.293182 C44.91124,139.027718 44.9435408,139.969445 44.5133076,140.73526 C44.0830744,141.501075 43.2619951,141.963374 42.3840909,141.934091 L32.8318182,141.934091 C32.0176713,141.91958 31.268934,141.485043 30.8524449,140.785341 C30.4359558,140.085639 30.4109592,139.220304 30.7863636,138.497727 C33.3227273,133.588636 41.5045455,133.854545 44.4295455,138.293182 Z"
              class="stroke fill-light"
              stroke-width="2.04545455"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M51.1386364,79.7727273 L51.1386364,78.3613636 C51.1386364,65.1102952 40.396523,54.3681818 27.1454545,54.3681818 C13.8943861,54.3681818 3.15227273,65.1102952 3.15227273,78.3613636 L3.15227273,99.6136364 L11.6204545,99.6136364 L11.6204545,110.904545 L42.6704545,110.904545 L42.6704545,79.7727273 C42.6704545,91.8818182 53.1022727,100.943182 62.4295455,100.943182 L62.4295455,92.5568182 C57.8272727,92.5568182 51.1386364,87.6068182 51.1386364,79.7727273 Z"
              class="fill-white"
              fill-rule="nonzero" />
            <path
              id="Path"
              d="M51.1386364,79.7727273 L51.1386364,78.3613636 C51.1386364,65.1102952 40.396523,54.3681818 27.1454545,54.3681818 C13.8943861,54.3681818 3.15227273,65.1102952 3.15227273,78.3613636 L3.15227273,99.6136364 L11.6204545,99.6136364 L11.6204545,110.904545 L42.6704545,110.904545 L42.6704545,79.7727273 C42.6704545,91.8818182 53.1022727,100.943182 62.4295455,100.943182 L62.4295455,92.5568182 C57.8272727,92.5568182 51.1386364,87.6068182 51.1386364,79.7727273 Z"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M16.9590909,56.7 L16.9590909,56.7 L27.1863636,61.0568182 L37.4136364,56.7 L37.4136364,56.7 C30.9356815,53.6538686 23.4370458,53.6538686 16.9590909,56.7 L16.9590909,56.7 Z"
              class="stroke fill-white"
              stroke-width="2.04545455"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M37.3113636,56.7409091 L21.5,63.4090909 C20.6306562,63.7787434 20.0667862,64.6326037 20.0681792,65.5772727 C20.0681792,73.7590909 20.0681792,110.802273 20.0681792,110.802273"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M66.6636364,92.5568182 L63.8409091,92.5568182 L63.8409091,101.025 L66.6636364,101.025 C68.1763314,101.025 69.5741193,100.217987 70.3304669,98.9079546 C71.0868144,97.5979223 71.0868144,95.9838959 70.3304669,94.6738636 C69.5741193,93.3638312 68.1763314,92.5568182 66.6636364,92.5568182 L66.6636364,92.5568182 Z"
              class="stroke fill-white"
              stroke-width="2.04545455"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="11.6204545"
              y1="71.3863636"
              x2="11.6204545"
              y2="99.6136364"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="42.6704545"
              y1="71.3863636"
              x2="42.6704545"
              y2="79.8545455"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M11.6204545,105.259091 C11.6204545,107.597515 9.72478747,109.493182 7.38636364,109.493182 C5.0479398,109.493182 3.15227273,107.597515 3.15227273,105.259091 L3.15227273,99.6136364 L11.6204545,99.6136364 L11.6204545,105.259091 Z"
              class="stroke fill-white"
              stroke-width="2.04545455"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <rect
              id="Rectangle"
              class="stroke fill-white"
              stroke-width="2.04545455"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round"
              x="58.1954545"
              y="89.9590909"
              width="5.64545455"
              height="13.6431818"
              rx="2.04545455" />
            <path
              id="Path"
              d="M2.6,93.9681818 L11.6204545,93.9681818 L11.6204545,99.6136364 L2.6,99.6136364 C1.47032665,99.6136364 0.554545455,98.6978552 0.554545455,97.5681818 L0.554545455,96.0136364 C0.554545455,94.883963 1.47032665,93.9681818 2.6,93.9681818 Z"
              class="stroke fill-white"
              stroke-width="2.04545455"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M25.7340909,67.1522727 C24.9546163,67.1522727 24.3227273,67.7841618 24.3227273,68.5636364 C24.3227273,69.343111 24.9546163,69.975 25.7340909,69.975 C26.5135655,69.975 27.1454545,69.343111 27.1454545,68.5636364 C27.1454545,67.7841618 26.5135655,67.1522727 25.7340909,67.1522727 L25.7340909,67.1522727 Z"
              fill="#0066A4"
              fill-rule="nonzero" />
            <path
              id="Path"
              d="M31.3795455,67.1522727 C30.6000708,67.1522727 29.9681818,67.7841618 29.9681818,68.5636364 C29.9681818,69.343111 30.6000708,69.975 31.3795455,69.975 C32.1590201,69.975 32.7909091,69.343111 32.7909091,68.5636364 C32.7909091,67.7841618 32.1590201,67.1522727 31.3795455,67.1522727 L31.3795455,67.1522727 Z"
              fill="#0066A4"
              fill-rule="nonzero" />
            <path
              id="Path"
              d="M25.7340909,75.6818182 C25.1632476,75.6818182 24.6486132,76.0256859 24.4301609,76.5530763 C24.2117087,77.0804668 24.3324589,77.6875194 24.7361061,78.0911666 C25.1397533,78.4948138 25.7468059,78.6155641 26.2741964,78.3971118 C26.8015868,78.1786595 27.1454545,77.6640251 27.1454545,77.0931818 C27.1454545,76.3137072 26.5135655,75.6818182 25.7340909,75.6818182 L25.7340909,75.6818182 Z"
              fill="#0066A4"
              fill-rule="nonzero" />
            <path
              id="Path"
              d="M31.3795455,75.6818182 C30.8087021,75.6818182 30.2940678,76.0256859 30.0756155,76.5530763 C29.8571632,77.0804668 29.9779135,77.6875194 30.3815607,78.0911666 C30.7852078,78.4948138 31.3922605,78.6155641 31.9196509,78.3971118 C32.4470414,78.1786595 32.7909091,77.6640251 32.7909091,77.0931818 C32.7909091,76.3137072 32.1590201,75.6818182 31.3795455,75.6818182 L31.3795455,75.6818182 Z"
              fill="#0066A4"
              fill-rule="nonzero" />
            <path
              id="Path"
              d="M25.7340909,84.0886364 C24.9546163,84.0886364 24.3227273,84.7205254 24.3227273,85.5 C24.3227273,86.2794746 24.9546163,86.9113636 25.7340909,86.9113636 C26.5135655,86.9113636 27.1454545,86.2794746 27.1454545,85.5 C27.1454545,84.7205254 26.5135655,84.0886364 25.7340909,84.0886364 L25.7340909,84.0886364 Z"
              fill="#0066A4"
              fill-rule="nonzero" />
            <path
              id="Path"
              d="M31.3795455,84.0886364 C30.6000708,84.0886364 29.9681818,84.7205254 29.9681818,85.5 C29.9681818,86.2794746 30.6000708,86.9113636 31.3795455,86.9113636 C32.1590201,86.9113636 32.7909091,86.2794746 32.7909091,85.5 C32.7909091,84.7205254 32.1590201,84.0886364 31.3795455,84.0886364 Z"
              fill="#0066A4"
              fill-rule="nonzero" />
            <path
              id="Path"
              d="M25.7340909,92.5568182 C24.9546163,92.5568182 24.3227273,93.1887072 24.3227273,93.9681818 C24.3227273,94.7476564 24.9546163,95.3795455 25.7340909,95.3795455 C26.5135655,95.3795455 27.1454545,94.7476564 27.1454545,93.9681818 C27.1454545,93.1887072 26.5135655,92.5568182 25.7340909,92.5568182 L25.7340909,92.5568182 Z"
              fill="#0066A4"
              fill-rule="nonzero" />
            <path
              id="Path"
              d="M31.3795455,92.5568182 C30.6000708,92.5568182 29.9681818,93.1887072 29.9681818,93.9681818 C29.9681818,94.7476564 30.6000708,95.3795455 31.3795455,95.3795455 C32.1590201,95.3795455 32.7909091,94.7476564 32.7909091,93.9681818 C32.7909091,93.1887072 32.1590201,92.5568182 31.3795455,92.5568182 Z"
              fill="#0066A4"
              fill-rule="nonzero" />
            <path
              id="Path"
              d="M27.125,49.7454545 C33.2686739,49.7298318 38.6921407,45.7305426 40.5227273,39.8659091 L40.5227273,39.8659091 C44.9818182,39.8659091 45.2477273,32.8090909 41.2181818,32.8090909 L41.2181818,29.9863636 C41.2181818,22.1916175 34.8992916,15.8727273 27.1045455,15.8727273 C19.3097993,15.8727273 12.9909091,22.1916175 12.9909091,29.9863636 L12.9909091,32.7272727 C8.9,32.7272727 9.22727273,39.7840909 13.6863636,39.7840909 L13.6863636,39.7840909 C15.4921683,45.6955098 20.9439219,49.7366118 27.125,49.7454545 L27.125,49.7454545 Z"
              class="stroke fill-white"
              stroke-width="2.04545455"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M22.5431818,33.0136364 C21.5716627,33.0136364 20.7840909,33.8012082 20.7840909,34.7727273 C20.7840909,35.7442464 21.5716627,36.5318182 22.5431818,36.5318182 C23.5147009,36.5318182 24.3022727,35.7442464 24.3022727,34.7727273 C24.3022727,33.8012082 23.5147009,33.0136364 22.5431818,33.0136364 Z"
              fill="#0066A4"
              fill-rule="nonzero" />
            <path
              id="Path"
              d="M31.7272727,33.0136364 C30.7557536,33.0136364 29.9681818,33.8012082 29.9681818,34.7727273 C29.9681818,35.7442464 30.7557536,36.5318182 31.7272727,36.5318182 C32.6987918,36.5318182 33.4863636,35.7442464 33.4863636,34.7727273 C33.4863636,33.8012082 32.6987918,33.0136364 31.7272727,33.0136364 Z"
              fill="#0066A4"
              fill-rule="nonzero" />
            <circle
              id="Oval"
              class="fill-light"
              fill-rule="nonzero"
              cx="18.6772727"
              cy="38.6590909"
              r="1.41136364" />
            <circle
              id="Oval"
              class="fill-light"
              fill-rule="nonzero"
              cx="35.6136364"
              cy="38.6590909"
              r="1.41136364" />
            <path
              id="Path"
              d="M23.5454545,42.9545455 C25.6821225,44.3788505 28.4656048,44.3788505 30.6022727,42.9545455"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M15.8545455,0.347727273 L38.3545455,0.347727273 C40.8712321,0.350736719 43.0820006,2.01924131 43.775,4.43863636 L44.4704545,6.87272727 C45.0952948,9.05915993 45.0453896,11.3833129 44.3272727,13.5409091 L41.1977273,22.9295455 L13.0113636,22.9295455 L9.88181818,13.5409091 C9.16370128,11.3833129 9.11379616,9.05915993 9.73863636,6.87272727 L10.4340909,4.43863636 C11.1270903,2.01924131 13.3378588,0.350736719 15.8545455,0.347727273 Z"
              class="stroke fill-white"
              stroke-width="2.04545455"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <rect
              id="Rectangle"
              class="stroke fill-white"
              stroke-width="2.04545455"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round"
              x="13.0113636"
              y="22.9295455"
              width="28.2272727"
              height="8.46818182" />
            <path
              id="Path"
              d="M22.9113636,0.347727273 C26.0292621,0.347727273 28.5568182,2.87528337 28.5568182,5.99318182"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M76.0113636,91.3704545 L114.875,91.3704545 C116.004673,91.3704545 116.920455,92.2862357 116.920455,93.4159091 L116.920455,109.779545 L73.9659091,109.779545 L73.9659091,93.4159091 C73.9659091,92.2862357 74.8816903,91.3704545 76.0113636,91.3704545 Z"
              class="fill-white"
              fill-rule="nonzero" />
            <path
              id="Path"
              d="M76.0113636,91.3704545 L114.875,91.3704545 C116.004673,91.3704545 116.920455,92.2862357 116.920455,93.4159091 L116.920455,109.779545 L73.9659091,109.779545 L73.9659091,93.4159091 C73.9659091,92.2862357 74.8816903,91.3704545 76.0113636,91.3704545 Z"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M76.0113636,72.9613636 L92.375,72.9613636 L92.375,81.1431818 C92.375,82.2728552 91.4592188,83.1886364 90.3295455,83.1886364 L78.0568182,83.1886364 C76.9271448,83.1886364 76.0113636,82.2728552 76.0113636,81.1431818 L76.0113636,72.9613636 L76.0113636,72.9613636 Z"
              class="fill-light"
              fill-rule="nonzero" />
            <line
              id="Path"
              x1="76.0113636"
              y1="75.0068182"
              x2="73.9659091"
              y2="75.0068182"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="94.4204545"
              y1="75.0068182"
              x2="92.375"
              y2="75.0068182"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M92.6409091,71.9795455 C93.0909091,70.3431818 89.9409091,68.0318182 85.5840909,66.825 C81.2272727,65.6181818 77.4022727,65.9454545 76.8704545,67.5613636 L76.5840909,68.5431818 L92.3340909,72.9613636 L92.6409091,71.9795455 Z"
              class="stroke fill-light"
              stroke-width="2.04545455"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <circle
              id="Oval"
              class="stroke fill-light"
              stroke-width="2.03982179"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round"
              transform="translate(85.843250, 65.195591) rotate(-74.291362) translate(-85.843250, -65.195591) "
              cx="85.84325"
              cy="65.1955909"
              r="2.03982179" />
            <path
              id="Path"
              d="M76.0113636,72.9613636 L92.375,72.9613636 L92.375,81.1431818 C92.375,82.2728552 91.4592188,83.1886364 90.3295455,83.1886364 L78.0568182,83.1886364 C76.9271448,83.1886364 76.0113636,82.2728552 76.0113636,81.1431818 L76.0113636,72.9613636 L76.0113636,72.9613636 Z"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M73.0863636,69.8522727 C73.0863636,69.8522727 69.2818182,66.1704545 70.1,64.6977273 C70.866299,63.2317288 70.332478,61.4221661 68.8931818,60.6068182 C68.4658719,60.3740938 67.9887606,60.2477996 67.5022727,60.2386364 C67.6428902,58.2237514 66.2919595,56.4077976 64.321705,55.9632397 C62.3514505,55.5186819 60.3516258,56.578589 59.6134115,58.4586353 C58.8751972,60.3386816 59.619562,62.4761154 61.3659091,63.4909091 L73.0863636,69.8522727 Z"
              class="stroke fill-white"
              stroke-width="2.04545455"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <rect
              id="Rectangle"
              class="fill-light"
              fill-rule="nonzero"
              x="98.5113636"
              y="60.6886364"
              width="16.3636364"
              height="22.5"
              rx="2.04545455" />
            <path
              id="Path"
              d="M98.5113636,64.7795455 C96.2520169,64.7795455 94.4204545,62.9479831 94.4204545,60.6886364"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M118.965909,60.6886364 C118.965909,62.9479831 117.134347,64.7795455 114.875,64.7795455"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <rect
              id="Rectangle"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round"
              x="98.5113636"
              y="60.6886364"
              width="16.3636364"
              height="22.5"
              rx="2.04545455" />
            <path
              id="Path"
              d="M115.897727,45.3477273 C114.348178,45.3573514 112.937069,46.2416613 112.252752,47.6319515 C111.568435,49.0222417 111.728384,50.6798443 112.665909,51.9136364 C112.141117,52.2869848 111.822814,52.8856974 111.806818,53.5295455 C111.806818,54.6592188 112.722599,55.575 113.852273,55.575 C114.981946,55.575 115.897727,54.6592188 115.897727,53.5295455 C118.157074,53.5295455 119.988636,51.6979831 119.988636,49.4386364 C119.988636,47.1792897 118.157074,45.3477273 115.897727,45.3477273 Z"
              class="stroke fill-white"
              stroke-width="2.04545455"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M99.125,46.8409091 C100.763695,45.1480563 101.033652,42.5546711 99.778744,40.5606105 C98.5238365,38.56655 96.0689095,37.687996 93.8337443,38.433051 C91.5985791,39.1781061 90.1617699,41.3539055 90.3542802,43.7020985 C90.5467905,46.0502915 92.3187872,47.9630255 94.6454545,48.3340909 C94.0577634,49.8447776 94.7466028,51.551984 96.2181364,52.2317956 C97.6896701,52.9116072 99.4361374,52.3294515 100.205477,50.902682 C100.974817,49.4759125 100.501565,47.6968437 99.125,46.8409091 L99.125,46.8409091 Z"
              class="stroke fill-white"
              stroke-width="2.04545455"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M78.0568182,91.3704545 L78.0568182,89.325 C78.0568182,88.1953266 78.9725994,87.2795455 80.1022727,87.2795455 L81.125,87.2795455"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M90.3295455,91.3704545 L90.3295455,89.325 C90.3295455,88.1953266 89.4137643,87.2795455 88.2840909,87.2795455 L87.2613636,87.2795455"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M100.556818,91.3704545 L100.556818,89.325 C100.556818,88.1953266 101.472599,87.2795455 102.602273,87.2795455 L103.625,87.2795455"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M112.829545,91.3704545 L112.829545,89.325 C112.829545,88.1953266 111.913764,87.2795455 110.784091,87.2795455 L109.761364,87.2795455"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables.scss' as *;

  .fill-extra-light {
    fill: var(--iconColorFaded9);
  }

  .stroke {
    stroke: var(--iconColor);
  }

  .fill-light {
    fill: var(--iconColorFaded6);
  }

  .fill-white {
    fill: #ffffff;
  }
</style>
